//Google Login changes
import { CredentialResponse } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import { setUserId, trackEvent } from "../utils/googleanalytics";

interface GoogleJwtPayload {
  sub: string;
  email?: string;
  name?: string;
}

// We add a 'callback' parameter so React can pass its 'login' function here
export const handleGoogleSuccess = (
  response: CredentialResponse,
  onSuccess: (token: string) => void
) => {
  if (response.credential) {
    console.log("Google ID Token received:", response.credential);

    // 1. Update the React State/Context immediately
    onSuccess(response.credential);
    const decoded: GoogleJwtPayload = jwtDecode(response.credential);

    // 3️⃣ Attach GA user_id (VERY IMPORTANT)
    setUserId(decoded.sub);

    // 4️⃣ Track login event
    trackEvent("login", {
      method: "google",
    });
    // 2. Future Step: Send to FastAPI
    /*
    fetch("https://your-api.com/auth/google", {
      method: "POST",
      body: JSON.stringify({ token: response.credential }),
      headers: { "Content-Type": "application/json" }
    });
    */
  }
};

export const handleGoogleError = () => {
  console.error("Google Login Failed");
};
